import { Immutable } from "immer";
import React from "react";
import { prefillSSRRetailData } from "tsi-common-react/src/apps/retail/ssr";
import { useSSRStorePrefill } from "tsi-common-react/src/store/reducers";

import { templates } from "@reactivated";

import { FlagshipNearestStores } from "../FlagshipNearestStores";

// TODO: The SSR initial render shows "Closest Tempur-Pedic Store to you is
// Unknown" and an empty tile list because store data depends on client-side
// geolocation. Unlike LocatorNearestStores (which checks isLoadingStores to
// show a spinner), FlagshipNearestStores has no loading guard. This was also
// the case with CSR but was hidden behind the JS load waterfall. Addressing
// this likely requires a component redesign rather than a quick fix.

type IProps = Immutable<templates.FlagshipNearestStoresTemplate>;

export const FlagshipNearestStoresSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            max_tiles: props.max_tiles,
            include_location_info: props.include_location_info,
        },
        prefillSSRRetailData,
    );

    return (
        <FlagshipNearestStores
            maxTiles={props.max_tiles}
            includeLocationInfo={props.include_location_info}
        />
    );
};
